import { cn } from '../../utils'

export function World({
	variant = '',
	xs,
	disabled,
}: {
	variant?: string
	xs?: boolean
	disabled?: boolean
}) {
	return (
		<svg
			width={xs ? '16' : '24'}
			height={xs ? '16' : '24'}
			viewBox="0 0 24 24"
			fill="none"
			className={cn(variant, disabled && 'stroke-gray-400')}
			stroke="currentColor"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M8.0001 3H9.0001C7.0501 8.84 7.0501 15.16 9.0001 21H8.0001"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M15 3C16.95 8.84 16.95 15.16 15 21"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M3 16V15C8.84 16.95 15.16 16.95 21 15V16"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M3 9.0001C8.84 7.0501 15.16 7.0501 21 9.0001"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	)
}
